import { render, staticRenderFns } from "./AppropriateSafeguards.vue?vue&type=template&id=7115e2ab&"
import script from "./AppropriateSafeguards.vue?vue&type=script&lang=js&"
export * from "./AppropriateSafeguards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports